import { Button, Form, FormInstance, Radio } from 'antd';
import dayjs from 'dayjs';
import DoctorCard from 'commons/components/doctorcard/DoctorCard';
import { REQUEST_STATUSES } from 'commons/types/common';
import { MeetingType, MEETING_TYPES } from 'commons/types/meetingsTypes';
import CGU_VALUES from 'components/cgu/CGUContentType';
import CGUs from 'components/cgu/CGUs';
import { useCurrentDoctor } from 'stores/doctors/doctorsHooks';
import { useAppSelector } from 'stores/hooks';
import { getCreateMeetingRequestStatus } from 'stores/meetings/meetingsSlice';

interface ScheduleCGUStepProps {
  form: FormInstance;
  nextRdvType: MeetingType;
  actionText?: string;
  reschedule?: boolean;
  hideCGUs?: boolean;
}
export default function ScheduleCGUStep({
  form,
  nextRdvType,
  actionText = 'Confirmer mon rendez-vous',
  reschedule = false,
  hideCGUs = false,
}: ScheduleCGUStepProps) {
  const createMeetingRequestStatus = useAppSelector(
    getCreateMeetingRequestStatus,
  );
  const hasCMU = Form.useWatch('hasCMU', form);
  const date = Form.useWatch(['meeting', 'date'], form);
  const lastCGUWatcher: boolean | undefined = Form.useWatch(
    CGU_VALUES[nextRdvType].length > 0 && !hideCGUs
      ? CGU_VALUES[nextRdvType][CGU_VALUES[nextRdvType].length - 1].key
      : '',
    form,
  );
  const doctorID = Form.useWatch(['meeting', 'doctorID'], form);
  const [doctor] = useCurrentDoctor(doctorID);

  return (
    <div className='flex flex-col items-center text-center'>
      <p className='text-sm w-56 text-center'>
        Nous avons trouvé un praticien disponible à cet horaire
      </p>
      <DoctorCard
        rdvType={nextRdvType}
        doctorName={`${doctor?.member?.firstName || ''} ${
          doctor?.member?.lastName || ''
        }`}
        avatar={doctor?.avatar}
        startDate={dayjs(date)}
      />
      {!reschedule && nextRdvType === MEETING_TYPES.RDV_3 && (
        <div className='border-t cgu'>
          <Form.Item
            label="J'atteste sur l'honneur avoir un régime spécial (CMU, Affection Longue Durée)"
            name='hasCMU'
            className='!mt-6'
          >
            <Radio.Group>
              <Radio.Button value>Oui</Radio.Button>
              <Radio.Button value={false}>Non</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </div>
      )}
      <div>
        {(reschedule ||
          hasCMU !== undefined ||
          nextRdvType !== MEETING_TYPES.RDV_3) && (
          <CGUs
            hideCGUs={hideCGUs}
            rdvType={nextRdvType}
            form={form}
          />
        )}
        {(lastCGUWatcher ||
          CGU_VALUES[nextRdvType].length === 0 ||
          hideCGUs) && (
          <Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              size='large'
              loading={createMeetingRequestStatus === REQUEST_STATUSES.PENDING}
              className='mt-4 !rounded-[32px] !h-14'
            >
              {nextRdvType !== MEETING_TYPES.RDV_3 || hasCMU || reschedule
                ? `${actionText}`
                : 'Confirmer mon RDV'}
            </Button>
          </Form.Item>
        )}
      </div>
    </div>
  );
}
